import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import NotificationEditItemDetails from "./NotificationEditItemDetails"
import NotificationEditItemDates from "./NotificationEditItemDates"
import NotificationEditLinkDetails from "./NotificationEditLinkDetails"

const NotificationEditItem = ({
    model,
    onEventChange,
    onValueChange,
    onExpiresToggle,
}) => (
    <ItemDetailsColumns>
        <ItemDetailsColumn>
            <NotificationEditItemDetails
                title={model.title}
                message={model.message}
                send_push={model.send_push}
                onEventChange={onEventChange}
            />
            <NotificationEditLinkDetails 
                link={model.link}
                type={model.type}
                entityId={model.entity_id}
                onEventChange={onEventChange}
            />
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <NotificationEditItemDates
                expires={model.expires}
                not_before={model.not_before}
                onValueChange={onValueChange}
                onExpiresToggle={onExpiresToggle}
            />
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default NotificationEditItem
